import type { WorkspaceOperationOutcome } from '@streamlain/copilot-realtime-contract';

export type Failure = Exclude<WorkspaceOperationOutcome['status'], 'done'>;
export const workspaceOperationMessageKey = (status: Failure) =>
  `com.streamlain.copilot.operation.${status}` as const;
export const failure = (status: Failure): WorkspaceOperationOutcome => ({
  status,
  messageKey: workspaceOperationMessageKey(status),
});
